// extracted by mini-css-extract-plugin
export default {"input":"styles_input__tRJqc","drop_area":"styles_drop_area__soe4j"};